/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Rtx.Verbum.Api | v1
 * OpenAPI spec version: 1.0.0
 */

import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { useMutation, useQuery } from '@tanstack/react-query'
import { customInstance } from '../../../../core/custom-instance'
import type {
  CommunicationPolicyDto,
  ConfirmBrandingLogoDto,
  DataEnvelopeOfBrandingLogoResultDto,
  DataEnvelopeOfCommunicationPolicyDto,
  DataEnvelopeOfTenantBrandingResponseDto,
  DataEnvelopeOfTenantTimezoneDto,
  ErrorEnvelope,
  ResolveTenantParams,
  TenantTimezoneDto,
  UpdateTenantBrandingDto,
} from '../model'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K }
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    })
  }
  return result
}

/**
 * @summary Resolve tenant a partir do host/domínio
 */
export const resolveTenant = (
  params?: ResolveTenantParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfTenantBrandingResponseDto>(
    { url: `/v1/tenants/resolve`, method: 'GET', params, signal },
    options,
  )
}

export const getResolveTenantQueryKey = (params?: ResolveTenantParams) => {
  return [`/v1/tenants/resolve`, ...(params ? [params] : [])] as const
}

export const getResolveTenantQueryOptions = <
  TData = Awaited<ReturnType<typeof resolveTenant>>,
  TError = ErrorEnvelope,
>(
  params?: ResolveTenantParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof resolveTenant>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getResolveTenantQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof resolveTenant>>> = ({ signal }) =>
    resolveTenant(params, requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof resolveTenant>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ResolveTenantQueryResult = NonNullable<Awaited<ReturnType<typeof resolveTenant>>>
export type ResolveTenantQueryError = ErrorEnvelope

export function useResolveTenant<
  TData = Awaited<ReturnType<typeof resolveTenant>>,
  TError = ErrorEnvelope,
>(
  params: undefined | ResolveTenantParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof resolveTenant>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof resolveTenant>>,
          TError,
          Awaited<ReturnType<typeof resolveTenant>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useResolveTenant<
  TData = Awaited<ReturnType<typeof resolveTenant>>,
  TError = ErrorEnvelope,
>(
  params?: ResolveTenantParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof resolveTenant>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof resolveTenant>>,
          TError,
          Awaited<ReturnType<typeof resolveTenant>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useResolveTenant<
  TData = Awaited<ReturnType<typeof resolveTenant>>,
  TError = ErrorEnvelope,
>(
  params?: ResolveTenantParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof resolveTenant>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Resolve tenant a partir do host/domínio
 */

export function useResolveTenant<
  TData = Awaited<ReturnType<typeof resolveTenant>>,
  TError = ErrorEnvelope,
>(
  params?: ResolveTenantParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof resolveTenant>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getResolveTenantQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

/**
 * @summary Obtém o branding do tenant autenticado
 */
export const getCurrentBranding = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfTenantBrandingResponseDto>(
    { url: `/v1/tenants/current-branding`, method: 'GET', signal },
    options,
  )
}

export const getGetCurrentBrandingQueryKey = () => {
  return [`/v1/tenants/current-branding`] as const
}

export const getGetCurrentBrandingQueryOptions = <
  TData = Awaited<ReturnType<typeof getCurrentBranding>>,
  TError = ErrorEnvelope,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentBranding>>, TError, TData>>
  request?: SecondParameter<typeof customInstance>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetCurrentBrandingQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentBranding>>> = ({ signal }) =>
    getCurrentBranding(requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCurrentBranding>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCurrentBrandingQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCurrentBranding>>
>
export type GetCurrentBrandingQueryError = ErrorEnvelope

export function useGetCurrentBranding<
  TData = Awaited<ReturnType<typeof getCurrentBranding>>,
  TError = ErrorEnvelope,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentBranding>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentBranding>>,
          TError,
          Awaited<ReturnType<typeof getCurrentBranding>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrentBranding<
  TData = Awaited<ReturnType<typeof getCurrentBranding>>,
  TError = ErrorEnvelope,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCurrentBranding>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentBranding>>,
          TError,
          Awaited<ReturnType<typeof getCurrentBranding>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrentBranding<
  TData = Awaited<ReturnType<typeof getCurrentBranding>>,
  TError = ErrorEnvelope,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentBranding>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Obtém o branding do tenant autenticado
 */

export function useGetCurrentBranding<
  TData = Awaited<ReturnType<typeof getCurrentBranding>>,
  TError = ErrorEnvelope,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentBranding>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCurrentBrandingQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

/**
 * @summary Atualiza o branding do tenant autenticado
 */
export const updateCurrentBranding = (
  updateTenantBrandingDto: UpdateTenantBrandingDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfTenantBrandingResponseDto>(
    {
      url: `/v1/tenants/current-branding`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateTenantBrandingDto,
      signal,
    },
    options,
  )
}

export const getUpdateCurrentBrandingMutationKey = () => ['updateCurrentBranding'] as const

export const getUpdateCurrentBrandingMutationOptions = <
  TError = ErrorEnvelope,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCurrentBranding>>,
    TError,
    UpdateCurrentBrandingMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCurrentBranding>>,
  TError,
  UpdateCurrentBrandingMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateCurrentBrandingMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCurrentBranding>>,
    UpdateCurrentBrandingMutationVariables
  > = (props) => {
    const { data } = props ?? {}

    return updateCurrentBranding(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type UpdateCurrentBrandingMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCurrentBranding>>
>
export type UpdateCurrentBrandingMutationBody = UpdateTenantBrandingDto
export type UpdateCurrentBrandingMutationError = ErrorEnvelope
export type UpdateCurrentBrandingMutationVariables = { data: UpdateTenantBrandingDto }

/**
 * @summary Atualiza o branding do tenant autenticado
 */
export const useUpdateCurrentBranding = <TError = ErrorEnvelope, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateCurrentBranding>>,
      TError,
      UpdateCurrentBrandingMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateCurrentBranding>>,
  TError,
  UpdateCurrentBrandingMutationVariables,
  TContext
> => {
  return useMutation(getUpdateCurrentBrandingMutationOptions(options), queryClient)
}
/**
 * @summary Atualiza o fuso horário do tenant autenticado
 */
export const updateCurrentTimezone = (
  tenantTimezoneDto: TenantTimezoneDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfTenantTimezoneDto>(
    {
      url: `/v1/tenants/current-timezone`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: tenantTimezoneDto,
      signal,
    },
    options,
  )
}

export const getUpdateCurrentTimezoneMutationKey = () => ['updateCurrentTimezone'] as const

export const getUpdateCurrentTimezoneMutationOptions = <
  TError = ErrorEnvelope,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCurrentTimezone>>,
    TError,
    UpdateCurrentTimezoneMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCurrentTimezone>>,
  TError,
  UpdateCurrentTimezoneMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateCurrentTimezoneMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCurrentTimezone>>,
    UpdateCurrentTimezoneMutationVariables
  > = (props) => {
    const { data } = props ?? {}

    return updateCurrentTimezone(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type UpdateCurrentTimezoneMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCurrentTimezone>>
>
export type UpdateCurrentTimezoneMutationBody = TenantTimezoneDto
export type UpdateCurrentTimezoneMutationError = ErrorEnvelope
export type UpdateCurrentTimezoneMutationVariables = { data: TenantTimezoneDto }

/**
 * @summary Atualiza o fuso horário do tenant autenticado
 */
export const useUpdateCurrentTimezone = <TError = ErrorEnvelope, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateCurrentTimezone>>,
      TError,
      UpdateCurrentTimezoneMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateCurrentTimezone>>,
  TError,
  UpdateCurrentTimezoneMutationVariables,
  TContext
> => {
  return useMutation(getUpdateCurrentTimezoneMutationOptions(options), queryClient)
}
export const getCommunicationPolicy = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfCommunicationPolicyDto>(
    { url: `/v1/tenants/communication-policy`, method: 'GET', signal },
    options,
  )
}

export const getGetCommunicationPolicyQueryKey = () => {
  return [`/v1/tenants/communication-policy`] as const
}

export const getGetCommunicationPolicyQueryOptions = <
  TData = Awaited<ReturnType<typeof getCommunicationPolicy>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getCommunicationPolicy>>, TError, TData>
  >
  request?: SecondParameter<typeof customInstance>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetCommunicationPolicyQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCommunicationPolicy>>> = ({ signal }) =>
    getCommunicationPolicy(requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCommunicationPolicy>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCommunicationPolicyQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCommunicationPolicy>>
>
export type GetCommunicationPolicyQueryError = unknown

export function useGetCommunicationPolicy<
  TData = Awaited<ReturnType<typeof getCommunicationPolicy>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCommunicationPolicy>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCommunicationPolicy>>,
          TError,
          Awaited<ReturnType<typeof getCommunicationPolicy>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCommunicationPolicy<
  TData = Awaited<ReturnType<typeof getCommunicationPolicy>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCommunicationPolicy>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCommunicationPolicy>>,
          TError,
          Awaited<ReturnType<typeof getCommunicationPolicy>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCommunicationPolicy<
  TData = Awaited<ReturnType<typeof getCommunicationPolicy>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCommunicationPolicy>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCommunicationPolicy<
  TData = Awaited<ReturnType<typeof getCommunicationPolicy>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCommunicationPolicy>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCommunicationPolicyQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const updateCommunicationPolicy = (
  communicationPolicyDto: CommunicationPolicyDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfCommunicationPolicyDto>(
    {
      url: `/v1/tenants/communication-policy`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: communicationPolicyDto,
      signal,
    },
    options,
  )
}

export const getUpdateCommunicationPolicyMutationKey = () => ['updateCommunicationPolicy'] as const

export const getUpdateCommunicationPolicyMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCommunicationPolicy>>,
    TError,
    UpdateCommunicationPolicyMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCommunicationPolicy>>,
  TError,
  UpdateCommunicationPolicyMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateCommunicationPolicyMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCommunicationPolicy>>,
    UpdateCommunicationPolicyMutationVariables
  > = (props) => {
    const { data } = props ?? {}

    return updateCommunicationPolicy(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type UpdateCommunicationPolicyMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCommunicationPolicy>>
>
export type UpdateCommunicationPolicyMutationBody = CommunicationPolicyDto
export type UpdateCommunicationPolicyMutationError = unknown
export type UpdateCommunicationPolicyMutationVariables = { data: CommunicationPolicyDto }

export const useUpdateCommunicationPolicy = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateCommunicationPolicy>>,
      TError,
      UpdateCommunicationPolicyMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateCommunicationPolicy>>,
  TError,
  UpdateCommunicationPolicyMutationVariables,
  TContext
> => {
  return useMutation(getUpdateCommunicationPolicyMutationOptions(options), queryClient)
}
export const confirmBrandingLogo = (
  confirmBrandingLogoDto: ConfirmBrandingLogoDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfBrandingLogoResultDto>(
    {
      url: `/v1/tenants/branding/logo/confirm`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: confirmBrandingLogoDto,
      signal,
    },
    options,
  )
}

export const getConfirmBrandingLogoMutationKey = () => ['confirmBrandingLogo'] as const

export const getConfirmBrandingLogoMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmBrandingLogo>>,
    TError,
    ConfirmBrandingLogoMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof confirmBrandingLogo>>,
  TError,
  ConfirmBrandingLogoMutationVariables,
  TContext
> => {
  const mutationKey = getConfirmBrandingLogoMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof confirmBrandingLogo>>,
    ConfirmBrandingLogoMutationVariables
  > = (props) => {
    const { data } = props ?? {}

    return confirmBrandingLogo(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type ConfirmBrandingLogoMutationResult = NonNullable<
  Awaited<ReturnType<typeof confirmBrandingLogo>>
>
export type ConfirmBrandingLogoMutationBody = ConfirmBrandingLogoDto
export type ConfirmBrandingLogoMutationError = unknown
export type ConfirmBrandingLogoMutationVariables = { data: ConfirmBrandingLogoDto }

export const useConfirmBrandingLogo = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof confirmBrandingLogo>>,
      TError,
      ConfirmBrandingLogoMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof confirmBrandingLogo>>,
  TError,
  ConfirmBrandingLogoMutationVariables,
  TContext
> => {
  return useMutation(getConfirmBrandingLogoMutationOptions(options), queryClient)
}
